<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><em>For my own hardy perennials</em></p><p class="ded"><em>Bridget, Liz, Rachel, Trish and Vivvy</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FutureHomemake_dedi-1.vue?4b38ce40